import { render, staticRenderFns } from "./MainMenuStudent.vue?vue&type=template&id=2872f078&scoped=true"
import script from "./MainMenuStudent.vue?vue&type=script&lang=js"
export * from "./MainMenuStudent.vue?vue&type=script&lang=js"
import style0 from "./MainMenuStudent.vue?vue&type=style&index=0&id=2872f078&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2872f078",
  null
  
)

export default component.exports